import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterBy',
  pure: false
})
export class FilterByPipe implements PipeTransform {
  transform(items: any[], key: any, value: any, lookupKeyPropertyName: any, args?: any[]): any {
    if (!key || value == undefined || value == 'null') {
      return items;
    }
    else {
      return items.filter(item => item[key] == value);
    }
  }
  //transform(items: any[], key: any, value: any, lookupKeyPropertyName: any, defaultKeyValue: any, lookupLabelPropertyName: any, defaultLabelValue: any, args?: any[]): any {
  //  if (!key || !value || value == 'null') {
  //    return items;
  //  }
  //  else {
  //    var filteredItems = [{
  //      [lookupKeyPropertyName]: defaultKeyValue,
  //      [lookupLabelPropertyName]: defaultLabelValue

  //    },
  //    ...items.filter(item => item[key] == value)
  //    ];
  //    return filteredItems;
  //  }
  //}
}
